/**
 * Helper utility to parse and extract tenant subdomain from the current hostname.
 * Supports both local development (e.g. supplier.localhost) and production (e.g. supplier.yaseero.com).
 */
export const getSubdomain = () => {
    const hostname = window.location.hostname;
    
    // Hostnames to ignore (serve main admin / login portals)
    const ignoreList = [
        'localhost',
        'yaseero.com',
        'www.yaseero.com',
        'yaseero.ae',
        'www.yaseero.ae',
        'demo.yaseero.ae',
        '127.0.0.1'
    ];
    
    if (ignoreList.includes(hostname)) {
        return null;
    }
    
    // Local dev wildcard subdomains: e.g. supplier-a.localhost
    if (hostname.endsWith('.localhost')) {
        const sub = hostname.split('.localhost')[0];
        if (sub === 'demo') {
            return null;
        }
        return sub;
    }
    
    // Production subdomains: e.g. supplier-b.yaseero.com
    const parts = hostname.split('.');
    if (parts.length > 2) {
        // Strip out 'www' if present
        let sub = parts[0];
        if (sub === 'www') {
            sub = parts[1];
        }
        
        // Skip 'demo' subdomain (treat as main application)
        if (sub === 'demo') {
            return null;
        }
        
        return sub;
    }
    
    return null;
};
